<script setup>

// 为什么选择我们
const props = defineProps({
    footer: {
        type: Object,
        default: () => ({ webname: '盒子云' })
    }
})

</script>

<template>
    <div class="Heziyun-choice Heziyun-padding">
        <img src="@/static/img/index/background-blue.webp" class="Heziyun-imgs" alt="">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('index.choice1') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{ $t('index.choice2') }}</p>
            </div>

            <div class="Heziyun-selectContent">
                <div class="Heziyun-itemChoose" v-intersect="{ class: 'left-right', delay: 0 }">
                    <img src="@/static/img/index/itemChoose1.png" alt="" />
                    <span>{{ $t('index.choice3') }}</span>
                    <p>{{ $t('index.choice4') }}</p>
                </div>
                <div class="Heziyun-itemChoose" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <img src="@/static/img/index/itemChoose2.png" alt="" />
                    <span>{{ $t('index.choice5') }}</span>
                    <p>{{ $t('index.choice6') }}</p>
                </div>
                <div class="Heziyun-itemChoose" v-intersect="{ class: 'bottom-top', delay: 400 }">
                    <img src="@/static/img/index/itemChoose3.png" alt="" />
                    <span>{{ $t('index.choice7') }}</span>
                    <p>{{ $t('index.choice8') }}</p>
                </div>
                <div class="Heziyun-itemChoose" v-intersect="{ class: 'right-left', delay: 600 }">
                    <img src="@/static/img/index/itemChoose4.png" alt="" />
                    <span>{{ $t('index.choice9') }}</span>
                    <p>{{ $t('index.choice10') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
// 为什么选择我们
.Heziyun-choice {
    position: relative;

    .Heziyun-imgs {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    .Heziyun-commodity-title {
        position: relative;

        span {
            color: #fff;
        }

        p {
            color: #fff;
        }
    }

    .Heziyun-defaultWidth {


        .Heziyun-selectContent {
            position: relative;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 1rem;

            .Heziyun-itemChoose {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 0.7rem;

                img {
                    width: 3.5rem;
                    height: 3.5rem;
                }

                span {
                    color: #fff;
                    font-family: "思源黑";
                    font-size: 1rem;
                }

                p {
                    color: #fff;
                    line-height: 1.7;
                    text-align: center;
                }
            }
        }
    }

    .Heziyun-commodity-title2 {
        padding-top: 5rem;
    }

    .partners-section {
        width: 100%;
        overflow: hidden;
        position: relative;
        mask-image: linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%);
        display: flex;
        flex-direction: column;
        gap: 1.2rem;

        &:hover {
            .partners-track {
                animation-play-state: paused;
            }
        }

        @keyframes animationOne {
            from {
                transform: translate(100%);
                -webkit-transform: translate(100%);
                -moz-transform: translate(100%);
                -ms-transform: translate(100%);
                -o-transform: translate(100%);
            }

            to {
                transform: translate(-100%);
                -webkit-transform: translate(-100%);
                -moz-transform: translate(-100%);
                -ms-transform: translate(-100%);
                -o-transform: translate(-100%);
            }
        }

        @keyframes animationTwos {
            from {
                transform: translate(0%);
                -webkit-transform: translate(0%);
                -moz-transform: translate(0%);
                -ms-transform: translate(0%);
                -o-transform: translate(0%);
            }

            to {
                transform: translate(-200%);
                -webkit-transform: translate(-200%);
                -moz-transform: translate(-200%);
                -ms-transform: translate(-200%);
                -o-transform: translate(-200%);
            }
        }

        .partners-track {
            margin: 0 auto;
            transform: translateZ(0);
            backface-visibility: hidden;
            perspective: 1000px;
            will-change: transform;
            display: flex;

            div {
                display: flex;
                white-space: nowrap;
            }

            div:nth-child(1) {
                animation: animationOne var(--t) linear infinite;
                -webkit-animation: animationOne var(--t) linear infinite;
            }

            div:nth-child(2) {
                animation: animationTwos var(--t) linear infinite;
                -webkit-animation: animationTwos var(--t) linear infinite;
                animation-delay: calc(var(--t) / -2);
            }
        }


        .partner-logo {
            flex: 0 0 auto;
            width: 13rem;
            height: 4rem;
            padding: 0.5rem;
            margin: 0 3rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: transparent;

            &:hover {
                background-color: rgb(203 203 203 / 10%);
            }
        }

        .partner-logo img {
            max-width: 80%;
            max-height: 80%;
            object-fit: contain;
        }
    }


}

// 为什么选择我们
@media (max-width: 768px) {
    .Heziyun-choice {
        padding: 8vw 0;

        .Heziyun-defaultWidth {
            font-family: "思源黑";

            .Heziyun-selectContent {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 6vw 4vw;

                .Heziyun-itemChoose {
                    gap: 2vw;

                    img {
                        width: 12vw;
                        height: 12vw;
                    }

                    span {
                        font-size: 4vw;
                    }

                    p {
                        font-size: 3vw;
                        text-align: center;
                    }
                }
            }
        }
    }
}
</style>